import React from "react";

export default function UserCard({ user, onClick }) {
  return (
    <div
      onClick={() => onClick(user)}
      className="bg-white rounded-xl shadow hover:shadow-lg transition cursor-pointer p-6 text-center relative"
    >
      {/* Gold badge if applicable */}
      {user.membership_type === "gold" && (
        <span className="absolute top-3 right-3 bg-yellow-400 text-white text-xs font-semibold px-3 py-1 rounded-full shadow-sm">
          🌟 Gold Member
        </span>
      )}

      {/* Circular image with gold ring if gold user */}
      <div
        className={`w-24 h-24 mx-auto mb-4 rounded-full overflow-hidden border-4 ${
          user.membership_type === "gold"
            ? "border-yellow-400"
            : "border-gray-200"
        }`}
      >
        <img
          src={user.profile_image || "/image/operator.png"}
          alt={`${user.firstName} ${user.lastName}`}
          className="w-full h-full object-cover"
        />
      </div>

      <h3 className="text-lg font-semibold text-gray-800">
        {user.firstName}, {user.age}
      </h3>
      <p className="text-sm text-gray-500">
        {user.city}, {user.state}, {user.country}
      </p>

      <button
        className="mt-4 bg-blue-500 hover:bg-blue-600 text-white text-sm px-4 py-2 rounded-full font-medium"
        onClick={(e) => {
          e.stopPropagation();
          onClick(user);
        }}
      >
        View Profile
      </button>
    </div>
  );
}
